/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsCustomOrphanedResource extends models.RecommendationBaseForFinopsCustomResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsCustomOrphanedResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsCustomOrphanedResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsCustomOrphanedResource>): RecommendationForFinopsCustomOrphanedResource {
        let obj = Object.assign(new RecommendationForFinopsCustomOrphanedResource(), model);
        RecommendationForFinopsCustomOrphanedResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsCustomOrphanedResource>): RecommendationForFinopsCustomOrphanedResource {
        if (!model) return null;
        return RecommendationForFinopsCustomOrphanedResource.newInstance(<RecommendationForFinopsCustomOrphanedResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsCustomOrphanedResource) {
        if (!obj) return;

        models.RecommendationForFinopsCustomOrphanedResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsCustomOrphanedResource): boolean {
        if (models.RecommendationBaseForFinopsCustomResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsCustomOrphanedResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
